import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface ComplianceNoticeProps {
  className?: string;
}

/**
 * Reusable compliance disclaimer shown wherever documents, notices, violations,
 * or other legal-adjacent communications can be generated through BlockBoard.
 */
const ComplianceNotice: React.FC<ComplianceNoticeProps> = ({ className = '' }) => (
  <div
    className={`rounded-lg border border-amber-500/30 bg-amber-500/10 p-4 flex items-start gap-3 ${className}`}
    role="note"
  >
    <ExclamationTriangleIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
    <p className="text-sm text-amber-700 dark:text-amber-200 leading-relaxed">
      Documents and notices generated through BlockBoard are provided as workflow
      tools only. Users are responsible for ensuring compliance with all applicable
      legal requirements, delivery methods, and deadlines.
    </p>
  </div>
);

export default ComplianceNotice;
